import { ComponentsOverrides, Theme } from '@mui/material';

export const TabsStyles: ComponentsOverrides<Theme>['MuiTab'] =
  {
    root: {
      textTransform: 'unset',
      px: 2,
      minHeight: '3rem',
      minWidth: 100
    },
  };